import { useAdminAuth } from '@/lib/hooks/use-admin-auth';
import { LoadingSkeleton } from '@/lib/utils/utils';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Shield } from 'lucide-react';

interface AdminRouteProps {
    children: React.ReactNode;
}

export function AdminRoute({ children }: AdminRouteProps) {
    const { isAdmin, isLoading, user } = useAdminAuth();

    if (isLoading) {
        return <LoadingSkeleton />;
    }

    if (!user) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <Card className="w-full max-w-md">
                    <CardHeader>
                        <CardTitle className="flex items-center gap-2">
                            <Shield className="w-5 h-5" />
                            Authentication Required
                        </CardTitle>
                    </CardHeader>
                    <CardContent>
                        <p>Please sign in to access admin features.</p>
                    </CardContent>
                </Card>
            </div>
        );
    }

    if (!isAdmin) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <Card className="w-full max-w-md">
                    <CardHeader>
                        <CardTitle className="flex items-center gap-2">
                            <Shield className="w-5 h-5" />
                            Access Denied
                        </CardTitle>
                    </CardHeader>
                    <CardContent>
                        <p>You don't have admin privileges to access this page.</p>
                    </CardContent>
                </Card>
            </div>
        );
    }

    return <>{children}</>;
}
